<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">500</h1>
          <h4 class="pt-3">{{$t('page500_view.title')}}</h4>
          <p class="text-muted" v-t="$t('page500_view.content')"/>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: 'Page500',
  created() {
    window.document.title = 'Error 500 - LDX'
  }
}
</script>
